import client from '../httpclient';

const logoffSession = (): Promise<void> => client
  .post(`/re/v1/logoff-session`);

export default logoffSession;
